import { render } from "./CarouselFull.vue?vue&type=template&id=3a9dc9cd&scoped=true"
import script from "./CarouselFull.vue?vue&type=script&lang=js"
export * from "./CarouselFull.vue?vue&type=script&lang=js"

import "./CarouselFull.vue?vue&type=style&index=0&id=3a9dc9cd&scoped=true&lang=css"
import "./CarouselFull.vue?vue&type=style&index=1&id=3a9dc9cd&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9dc9cd"]])

export default __exports__